import React, { createContext, useContext } from "react";
import { useExternalEntities } from "../ExternalEntitiesProvider/ExternalEntitiesProvider";

/**
 * Prop type interface for ComponentQosContext.
 *
 * ============= NOTICE =============
 * | This is a snapshot of interface ComponentQosContextProps from
 * | core-client-telemetry and mean to expose to other partner of TwoUI. This is
 * | NOT meant to be in sync with core-client-telemetry interfaces.
 * ==========================================
 */
export interface TwoUIComponentQosContextType {
    readonly startOperation: (componentName: string, operationName: string, isInit: boolean) => void;
    readonly reportSuccess: (componentName: string, operationName: string, customData?: any) => void;
    readonly reportFailure: (componentName: string, operationName: string, error: Error, customData?: any) => void;
    readonly reportCancel: (componentName: string, operationName: string) => void;
}

const doNothingTwoUIComponentQos = {
    startOperation: (_componentName: string, _operationName: string, _isInit: boolean) => { return; },
    reportSuccess: (_componentName: string, _operationName: string, _customData?: any) => { return; },
    reportFailure: (_componentName: string, _operationName: string, _error: Error, _customData?: any) => { return; },
    reportCancel: (_componentName: string, _operationName: string) => { return; }
};

export const TwoUIComponentQosContext = createContext<TwoUIComponentQosContextType | null>(doNothingTwoUIComponentQos);

/**
 * Context provider for component QoS in TwoUI
 */
export const TwoUIComponentQosProvider: React.FC = ({
    children
}) => {
    return (
        <TwoUIComponentQosContext.Provider value={doNothingTwoUIComponentQos}>
            {children}
        </TwoUIComponentQosContext.Provider>
    );
};

export const useTwoUIComponentQos = (): TwoUIComponentQosContextType => {

    const { componentQosContext: externalComponentQosContext } = useExternalEntities();

    let componentQosContext = TwoUIComponentQosContext;

    if (externalComponentQosContext) {
        componentQosContext = externalComponentQosContext;
    }

    const componentQos = useContext(componentQosContext);

    if (!componentQos) {
        throw new Error("TwoUIComponentQoS: Context is uninitialized");
    }

    return componentQos;
};
